/*
 * Finish-delivery.ts
 * Description: Includes the declaration
 * of the finishing delivery function
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Finish a delivery
 *
 * @return {Object} Promise - finished delivery
 * @param {Number} orderId - id of the delivery
 */
export function finishDelivery(orderId: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'deliveries/' + orderId,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                status: 'DELIVERED',
            },
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
